// extracted by mini-css-extract-plugin
export default {"gridFlex":"styles_gridFlex__rt44F","xmlName":"styles_xmlName__Aa50P","pre":"styles_pre__jHx-P"};